const actions = {
    GET_USER_LIST : "GET_USER_LIST",
    GET_USER : "GET_USER",
    ADD_USER : "ADD_USER",
    UPDATE_USER : "UPDATE_USER",
    SET_ACTIVITY : "SET_ACTIVITY",
};


const initialState = {
    users: [],
    filter: {
        pagesFilter: { pageCount: 1, currentPage: 1, maxItemsOnPage: 1},
        modelFilter: {}
    }
};

export default function reducer(state, action) {
    state = state || initialState;

    switch (action.type) {
    case actions.GET_USER_LIST:
    {
        return {
            ...state,
            users: action.payload.users,
            filter: action.payload.filter
        };
    }
    case actions.ADD_USER:
    {
        return {
            ...state,
            cards: [...state.users, action.user ]
        };
    }
    case actions.UPDATE_USER:
    {
        return {
            ...state,
            users: state.users.map((item, index) => {
                if (item.userId !== action.user.userId) {
                    // This isn't the item we care about - keep it as-is
                    return item;
                }

                // Otherwise, this is the one we want - return an updated value
                return {
                    ...item,
                    ...action.item
                };
            }),
        };
    }
    case actions.SET_ACTIVITY: {
        const users = [...state.users];
        const {userId, isActive} = action.payload;
        return{
            ...state,
            users: users.map(item => {
                if(item.applicationUserId === userId){
                    item.isActive = isActive;
                }

                return item;
            })
        }
    }
    default:
        return state;
    }
};

export const setUsers = (users, filter) => ({type: actions.GET_USER_LIST, payload: {users, filter}});
export const addUser = (user) => ({type: actions.ADD_USER, user});
export const editUser = (user) => ({type: actions.UPDATE_USER, user});
export const setUserActivity = (userId, isActive) => ({type: actions.SET_ACTIVITY, payload: {userId, isActive}});
